import { useMediaQuery, useTheme } from "@mui/material";

const GigpitLogo = () => {
  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <svg
      width={isSmallScreen ? 300 : 500}
      height="100%"
      viewBox="0 0 680 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5861_13650)">
        <path
          d="M0 48.7109H9.31738V18.667C9.31738 8.40032 20.6855 0 34.6621 0H115.354C129.33 0 140.698 8.40032 140.698 18.667V30.2402C140.698 34.1601 137.53 37.333 133.803 37.333H93.7363C89.8231 37.3329 86.6554 34.1601 86.6553 30.2402V29.4932C86.6552 22.2132 81.623 16.2402 75.1006 16.2402C68.5784 16.2405 63.3604 22.2134 63.3604 29.4932V48.7109H54.043V82.5068C54.043 89.7867 59.4472 95.5732 65.7832 95.5732C72.1192 95.5732 77.3368 89.7868 77.3369 82.5068V62.9062H65.7832V48.9062H124.485C128.212 48.9064 131.38 52.0801 131.38 56V104.906C131.38 108.826 128.212 112 124.485 112H25.3447C11.3681 112 0 103.6 0 93.333V48.7109Z"
          fill="white"
        />
        <path
          d="M139.207 48.7109H148.525V6.90625C148.526 3.1731 151.693 0 155.606 0H195.673C199.4 7.71284e-05 202.567 3.17314 202.567 6.90625V48.7109H193.25V104.906C193.25 108.826 190.082 112 186.354 112H146.289C142.376 112 139.207 108.826 139.207 104.906V48.7109Z"
          fill="white"
        />
        <path
          d="M201.077 48.7109H210.395V18.667C210.395 8.40032 221.763 0 235.739 0H316.431C330.407 0 341.775 8.40032 341.775 18.667V30.2402C341.775 34.1601 338.607 37.333 334.88 37.333H294.813C290.9 37.333 287.733 34.1601 287.732 30.2402V29.4932C287.732 22.2132 282.7 16.2402 276.178 16.2402C269.656 16.2404 264.438 22.2134 264.438 29.4932V48.7109H255.12V82.5068C255.12 89.7868 260.524 95.5732 266.86 95.5732C273.196 95.5732 278.414 89.7868 278.414 82.5068V62.9062H266.86V48.9062H325.562C329.289 48.9064 332.457 52.0801 332.457 56V104.906C332.457 108.826 329.289 112 325.562 112H226.421C212.444 112 201.077 103.6 201.077 93.333V48.7109Z"
          fill="white"
        />
        <path
          d="M427.312 48.7109V21.8398C427.311 18.6666 422.653 16.2403 417.062 16.2402H403.645V48.7109H394.327V55.8135H407.745C413.335 55.8134 417.994 53.3868 417.994 50.4004V48.7109H427.312ZM471.664 51.333C471.664 61.5996 460.297 69.9999 446.32 70H394.327V104.906C394.327 108.826 391.159 112 387.432 112H347.365C343.452 112 340.284 108.826 340.284 104.906V48.7109H349.602V6.90625C349.602 3.1731 352.77 0 356.684 0H455.638C469.614 0 480.982 8.40032 480.982 18.667V48.7109H471.664V51.333Z"
          fill="white"
        />
        <path
          d="M479.491 48.7109H488.8V6.90625C488.8 3.17323 491.968 0.000222411 495.881 0H535.947C539.674 0 542.843 3.1731 542.843 6.90625V48.7109H533.534V104.906C533.534 108.826 530.367 112 526.64 112H486.573C482.66 112 479.491 108.826 479.491 104.906V48.7109Z"
          fill="white"
        />
        <path
          d="M577.132 48.7109H586.45V23.333H553.838C549.925 23.333 546.756 20.1601 546.756 16.2402V6.90625C546.756 3.1731 549.925 0 553.838 0H673.104C676.831 0 680 3.1731 680 6.90625V16.2402C680 20.1601 676.832 23.333 673.104 23.333H641.611V48.7109H632.293V104.906C632.293 108.826 629.125 112 625.212 112H584.027C580.114 112 577.132 108.826 577.132 104.906V48.7109Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5861_13650">
          <rect width="680" height="112" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GigpitLogo;
